import { render, staticRenderFns } from "./FolderActions.vue?vue&type=template&id=634d1644&"
import script from "./FolderActions.vue?vue&type=script&lang=ts&"
export * from "./FolderActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports